
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"63","height":"39","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M57.855 0H5.145C2.308 0 0 2.3 0 5.125v28.75C0 36.701 2.308 39 5.145 39h52.71C60.692 39 63 36.7 63 33.875V5.125C63 2.299 60.692 0 57.855 0zm2.635 33.875a2.633 2.633 0 01-2.635 2.625H5.145a2.633 2.633 0 01-2.635-2.625V14.25h57.98v19.625zm0-28.375H2.51v-.375A2.633 2.633 0 015.145 2.5h52.71a2.633 2.633 0 012.635 2.625V5.5z"}}),_c('path',{attrs:{"d":"M8.282 24h22.436c.708 0 1.282-.672 1.282-1.5s-.574-1.5-1.282-1.5H8.282C7.574 21 7 21.672 7 22.5S7.574 24 8.282 24zM9.221 30H22.78c.674 0 1.221-.672 1.221-1.5s-.547-1.5-1.221-1.5H9.22C8.547 27 8 27.672 8 28.5S8.547 30 9.221 30zM30.723 27h-3.446c-.705 0-1.277.672-1.277 1.5s.572 1.5 1.277 1.5h3.446c.705 0 1.277-.672 1.277-1.5s-.572-1.5-1.277-1.5z"}})])])
          )
        }
      }
    